import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DocumentDetails } from 'src/app/core/models/DocumentDetails';
import { SharedService } from 'src/app/core/services/shared.service';
import { TpaEmailComponent } from 'src/app/pages/claims/components/claim-details/components/tpa-email/tpa-email.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mail-details',
  templateUrl: './mail-details.component.html',
  styleUrls: ['./mail-details.component.scss']
})
export class MailDetailsComponent implements OnInit {

  @Output() newItemEvent = new EventEmitter<string>();
  @Output() refreshEvent = new EventEmitter<string>();
  @Input() claimDetailsFetch: any;
  @Input() claimData: any;

  ngOnChanges(changes: SimpleChanges) {
    this.setClaimId(changes.claimDetailsFetch.currentValue);
    this.getClaimDetails(changes.claimData.currentValue);
  }

  constructor(
    private sharedService: SharedService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  mailDetails: any;
  claimId: any;
  claimDetails: any;
  documentBucket: any;
  singleDocument: any;
  allowActions = false;

  ngOnInit(): void {
  }

  setClaimId(details: any) {
    if (details) {
      this.claimId = details.claimId.replace(/[_]/g, '/');
      this.claimDetails = details;
      this.allowActions = true;
    } else {
      this.allowActions = false;
    }
  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  refreshClaim(value: any) {
    this.refreshEvent.emit(value);
  }

  getClaimDetails(data: any) {
    this.mailDetails = data;
  }

  back() {
    localStorage.removeItem('mailId');
    localStorage.removeItem('mailPage');
    this.addNewItem('list');
  }

  selectDocument(mail: any) {
    if (mail.isChecked) {
      mail.isChecked = false;
    } else {
      mail.isChecked = true;
    }

  }

  checkMode(mode: any) {
    if (mode === 'attachMail') {
      this.attachMail(mode);
    }
    else if (mode === 'attachDoc') {
      this.documentBucket = [];
      for (let mailDoc of this.mailDetails.attechments) {
        if (mailDoc.isChecked === true) {
          let docObj = {
            documentType: "Other Document",
            attachmentId: mailDoc.attechmentId
          }
          this.documentBucket.push(docObj);
        }
      }
      if (this.documentBucket.length === 0) {
        Swal.fire('', 'Select a Document First', 'warning');
      } else {
        this.attachMail(mode);
      }
    }
  }

  attachMail(mode: any) {
    Swal.showLoading();
    let submitData: any;
    if (mode === 'attachMail') {
      submitData = {
        claimId: this.claimId,
        messageId: this.mailDetails.id,
      }
    } else if (mode === 'attachDoc') {
      submitData = {
        claimId: this.claimId,
        messageId: this.mailDetails.id,
        documents: this.documentBucket
      }
    }
    //Creating final SubmitData object 
    this.sharedService.attachMailToClaim(submitData).subscribe(
      (res: any) => {
        this.refreshClaim('refresh');
        Swal.close();
        this.refreshClaim('refresh');
        Swal.fire('', 'Mail Attached Successfully', 'success');
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }

  attachTPAEmail(statusType: any) {
    Swal.showLoading();
    this.documentBucket = [];
    for (let mailDoc of this.mailDetails.attechments) {
      if (mailDoc.isChecked === true) {
        let docObj = {
          documentType: "Other Document",
          attachmentId: mailDoc.attechmentId
        }
        this.documentBucket.push(docObj);
      }
    }
    if (this.documentBucket.length === 0) {
      Swal.close();
      const dialogRef = this.dialog.open(TpaEmailComponent, {
        width: '80vw',
        height: '95vh',
        data: {
          claimDetails: this.claimDetails,
          mailTime: this.mailDetails.receivedTime,
          statusType: statusType,
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'success') {
          this.router.navigate(['/claims/0/ON_GOING'], { skipLocationChange: true });
        }
      });

    } else {
      if (this.documentBucket.length > 1) {
        Swal.close();
        Swal.fire('', 'Select a single Document', 'warning');
        return
      }

      let submitData: any
      submitData = {
        messageId: this.mailDetails.id,
        attachmentId: this.documentBucket[0].attachmentId,
      };

      const queryDoc = new DocumentDetails({});

      this.sharedService.downloadAttachment(submitData).subscribe(
        (res: any) => {
          queryDoc.$file = `data:application/${res.body.docType};base64,${res.body.docContent}`;
          queryDoc.$canDelete = true;
          queryDoc.$isAdded = false;
          queryDoc.$extension = res.body.docName.split('.').pop().toLowerCase();
          queryDoc.$name = res.body.docName;
          Swal.close();
          const dialogRef = this.dialog.open(TpaEmailComponent, {
            width: '80vw',
            height: '95vh',
            data: {
              claimDetails: this.claimDetails,
              statusType: statusType,
              mailTime: this.mailDetails.receivedTime,
              mailDocument: queryDoc
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result === 'success') {
              this.router.navigate(['/claims/0/ON_GOING'], { skipLocationChange: true });
            }
          });
        },
        (err: any) => {
          Swal.close();
          Swal.fire('', err ? err : err, 'error');
        }
      );
    }
  }

  downloadAttachment(documentObj: any) {
    let submitData: any
    submitData = {
      messageId: this.mailDetails.id,
      attachmentId: documentObj.attechmentId,
    };
    this.sharedService.downloadAttachment(submitData).subscribe(
      (res: any) => {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', `data:application/${res.body.docType};base64,${res.body.docContent}`);
        link.setAttribute('download', res.body.docName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }
}
